export function normalizeWordSeparators(str: string): string {
  return (str || '').toLowerCase().replace(/[-_ ]+/g, ' ')
}
